<mat-card [ngStyle]="{'width': getWidth()}" style="border-radius: 12px; padding: 0px;">
    <div container="1" class="body-container-all">
        <div class="mat-headline"
            style="padding-bottom: 16px; padding-top: 24px; padding-left: 24px; padding-right: 24px;">
            <ng-content select="[dialogTitle]"></ng-content>
        </div>
        <div style="padding-left: 24px; padding-right: 24px;">
            <ng-content select="[dialogHeader]"></ng-content>
        </div>

        <div class="body-container-body" style="padding-left: 24px; padding-right: 24px;">
            <ng-content select="[dialogBody]"></ng-content>
        </div>
        <div style="padding-bottom: 16px; padding-left: 16px; padding-right: 16px;">
            <ng-content select="[dialogFooter]"></ng-content>
        </div>

    </div>
</mat-card>
